import { render, staticRenderFns } from "./TableSupplier.vue?vue&type=template&id=2caaacb6&"
import script from "./TableSupplier.vue?vue&type=script&lang=js&"
export * from "./TableSupplier.vue?vue&type=script&lang=js&"
import style0 from "./TableSupplier.vue?vue&type=style&index=0&lang=stylus&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports